"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ramda_1 = require("ramda");
const apollo_link_1 = require("apollo-link");
class SuccessLink extends apollo_link_1.ApolloLink {
    constructor({ successHandler }) {
        super();
        this.successHandler = successHandler;
    }
    request(operation, forward) {
        return new apollo_link_1.Observable(observer => {
            forward(operation).subscribe({
                complete: (...args) => observer.complete(...args),
                error: (...args) => observer.error(...args),
                next: data => {
                    if (ramda_1.not(ramda_1.has('errors', data))) {
                        this.successHandler({ operation, data });
                    }
                    observer.next(data);
                },
            });
        });
    }
}
exports.SuccessLink = SuccessLink;
//# sourceMappingURL=SuccessLink.js.map